import { AppBar, makeStyles, Toolbar, useMediaQuery } from '@material-ui/core';
import StandardLogo from 'Core/assets/images/StandardLogo.svg';
import CollapsedMenuBar from 'Core/components/Navigation/CollapsedMenuBar';
import NavigationMenu from 'Core/components/Navigation/NavigationMenu';
import { FooterLoginTypeCode, getDefaultPortalStaticContentParam, getFooterContentByParams } from 'Core/ducks/footer';
import { fromResult } from 'Core/models/Async';
import * as O from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/pipeable';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ScrollToTop from 'Shared/components/ScrollToTop';
import { getUserClaims } from 'Shared/utilities/UserProfileUtilities';
import WithClaims from 'WithClaims';
import '../Navigation/CollapsedMenuBar.sass';
import LegalNoticeContent from './LegalNoticeContent';

const useStylesHeader = makeStyles((theme: any) => ({
  legal_header__no_auth: {
    [theme.breakpoints.down('sm')]: {
      minHeight: '4rem',
    },
  },

  logo_container__no_auth: {
    width: '100%',
    textAlign: 'left',
    padding: '0 1.5rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}));


const LegalNoticePage = () => {
  const dispatch = useDispatch();
  const classes = useStylesHeader();
  const userClaims = pipe(getUserClaims());
  const history = useHistory();
  const isMobileView = !useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

  const Menu = CollapsedMenuBar;

  useEffect(() => {
    const params = getDefaultPortalStaticContentParam();
    if (O.isSome(userClaims)) {
      params.loginTypeCd = FooterLoginTypeCode.AUTH;
      dispatch(getFooterContentByParams(params));
    } else {
      params.loginTypeCd = FooterLoginTypeCode.NON_AUTH;
      dispatch(getFooterContentByParams(params));
    }
  }, []);

  if (O.isSome(userClaims)) {
    return (
      <WithClaims>
        {claims => (
          <>
            <Menu userClaims={fromResult(claims)} />
            {!isMobileView && <NavigationMenu userClaims={fromResult(claims)} />}
            <LegalNoticeContent />
            {!isMobileView && <ScrollToTop />}
          </>
        )}
      </WithClaims>
    );
  }
  return (
    <>
      <AppBar className="collapsed-menu-bar" position="static">
        <Toolbar className={`${classes.legal_header__no_auth} collapsed-menu-bar__toolbar`}>
          <div className={`${classes.logo_container__no_auth}`}>
            <img
              src={StandardLogo}
              id="collapsed-menu-logo"
              onClick={() => history.push('/')}
              className="collapsed-menu-bar__main-logo"
              alt="Standard Logo"
            />
          </div>
        </Toolbar>
      </AppBar>
      <LegalNoticeContent />
      {!isMobileView && <ScrollToTop />}
    </>
  );
};

export default LegalNoticePage;
